<template>
  <div class="verify-container">
    <!-- 背景图模糊层 -->
    <div class="bg-layer"></div>

    <!-- 右上角语言切换 -->
    <div class="register-lang">
      <LangSwitcher @language-changed="onLanguageChanged" />
    </div>

    <template v-if="step == 1">
      <!-- 认证卡片 -->
      <div class="verify-card">
        <!-- 返回 -->
        <!-- <button type="button" class="back-btn" @click="handleBack">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path
              d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
              fill="currentColor"
            />
          </svg>
          返回
        </button> -->

        <!-- 标题区域 -->
        <div class="verify-header">
          <div class="status-badge">
            <span class="badge-dot"></span>
            身份认证 · 信息填写
          </div>
          <h1 class="title">账户认证</h1>
          <p class="subtitle">请填写您的真实身份信息，提交后将进行人工审核</p>
        </div>

        <!-- 认证表单 -->
        <form class="verify-form" @submit.prevent="handleSubmit">
          <div class="section-title">
            <span class="section-line"></span>
            账户安全
            <span class="section-line"></span>
          </div>

          <!-- ===== 密码 ===== -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">登录密码</span>
              <span class="label-required">*</span>
            </label>
            <div class="input-wrapper">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="form.password"
                placeholder="请设置登录密码（至少8位）"
                class="form-input"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="password-toggle"
                @click="showPassword = !showPassword"
              >
                <svg
                  v-if="showPassword"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                    fill="currentColor"
                  />
                </svg>
                <svg v-else viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
          </div>
          <!-- ===== 确认密码 ===== -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">确认登录密码</span>
              <span class="label-required">*</span>
            </label>
            <div class="input-wrapper">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <input
                :type="showConfirmPassword ? 'text' : 'password'"
                v-model="form.confirmPassword"
                placeholder="请再次输入登录密码"
                class="form-input"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="password-toggle"
                @click="showConfirmPassword = !showConfirmPassword"
              >
                <svg
                  v-if="showConfirmPassword"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                    fill="currentColor"
                  />
                </svg>
                <svg v-else viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
          </div>

          <!-- ===== 交易密码 ===== -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">交易密码</span>
              <span class="label-required">*</span>
            </label>
            <div class="input-wrapper">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <input
                :type="showTradePassword ? 'text' : 'password'"
                v-model="form.tradePassword"
                placeholder="请设置交易密码（至少6位）"
                class="form-input"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="password-toggle"
                @click="showTradePassword = !showTradePassword"
              >
                <svg
                  v-if="showTradePassword"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                    fill="currentColor"
                  />
                </svg>
                <svg v-else viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
          </div>
          <!-- ===== 确认交易密码 ===== -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">确认交易密码</span>
              <span class="label-required">*</span>
            </label>
            <div class="input-wrapper">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <input
                :type="showConfirmTradePassword ? 'text' : 'password'"
                v-model="form.confirmTradePassword"
                placeholder="请再次输入交易密码"
                class="form-input"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="password-toggle"
                @click="showConfirmTradePassword = !showConfirmTradePassword"
              >
                <svg
                  v-if="showConfirmTradePassword"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                    fill="currentColor"
                  />
                </svg>
                <svg v-else viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
          </div>

          <!-- ===== 安全问题 ===== -->
          <div class="section-title">
            <span class="section-line"></span>
            安全问题
            <span class="section-line"></span>
          </div>

          <!-- ===== 安全问题 ===== -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">安全问题</span>
              <span class="label-required">*</span>
            </label>
            <div class="input-wrapper">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-5 1.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="form.securityQuestion"
                placeholder="请输入安全问题"
                class="form-input"
              />
            </div>
          </div>

          <!-- ===== 安全问题答案 ===== -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">问题答案</span>
              <span class="label-required">*</span>
            </label>
            <div class="input-wrapper">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-5 1.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="form.securityQuestionAnswer"
                placeholder="请输入问题答案"
                class="form-input"
              />
            </div>
          </div>

          <!-- ===== 目标国家 ===== -->
          <div class="section-title">
            <span class="section-line"></span>
            基本信息
            <span class="section-line"></span>
          </div>

          <div class="form-group">
            <label class="form-label">
              <span class="label-text">目标国家</span>
              <span class="label-required">*</span>
            </label>
            <div class="country-select-wrapper">
              <div
                class="country-select"
                @click="toggleCountryDropdown"
                :class="{ active: countryDropdownOpen }"
              >
                <div class="country-select-display">
                  <span
                    v-if="selectedCountries.length === 0"
                    class="placeholder"
                  >
                    请选择目标国家
                  </span>
                  <span v-else class="selected-tags">
                    <span
                      v-for="country in selectedCountries"
                      :key="country"
                      class="country-tag"
                    >
                      {{ country }}
                      <button
                        type="button"
                        class="tag-remove"
                        @click.stop="removeCountry(country)"
                      >
                        ×
                      </button>
                    </span>
                  </span>
                  <svg
                    class="dropdown-arrow"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    :class="{ rotated: countryDropdownOpen }"
                  >
                    <path d="M7 10l5 5 5-5z" fill="currentColor" />
                  </svg>
                </div>
                <div v-if="countryDropdownOpen" class="country-dropdown">
                  <div
                    v-for="country in allCountries"
                    :key="country"
                    class="country-option"
                    @click.stop="toggleCountry(country)"
                  >
                    <span class="country-option-name">{{ country }}</span>
                    <span
                      v-if="selectedCountries.includes(country)"
                      class="country-check"
                      >✓</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ===== 手机号 ===== -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">手机号码</span>
              <span class="label-required">*</span>
            </label>
            <div class="input-wrapper">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-5 1.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <input
                type="tel"
                v-model="form.phone"
                placeholder="请输入手机号码"
                class="form-input"
                maxlength="11"
                autocomplete="tel"
              />
            </div>
          </div>

          <!-- ===== 真实姓名 ===== -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">真实姓名</span>
              <span class="label-required">*</span>
            </label>
            <div class="input-wrapper">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="form.realName"
                placeholder="请输入真实姓名（与身份证一致）"
                class="form-input"
                autocomplete="name"
              />
            </div>
          </div>

          <!-- ===== 身份证号 ===== -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">身份证号码</span>
              <span class="label-required">*</span>
            </label>
            <div class="input-wrapper">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path
                    d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM6 10h2v2H6zm0 4h8v2H6zm10 0h2v2h-2zm-6-4h8v2h-8z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="form.idNumber"
                placeholder="请输入身份证号码"
                class="form-input"
                maxlength="18"
                autocomplete="off"
              />
            </div>
          </div>

          <!-- ===== 身份证照片 ===== -->
          <div class="section-title">
            <span class="section-line"></span>
            身份证照片
            <span class="section-line"></span>
          </div>

          <div class="upload-grid">
            <!-- 正面照 -->
            <div class="upload-item">
              <div class="upload-label">
                <span class="upload-name">正面照</span>
                <span class="label-required">*</span>
              </div>
              <div
                class="upload-area"
                :class="{
                  'has-image': form.idFrontImage,
                  uploading: uploading === 'front',
                  dragover: dragOver === 'front',
                }"
                @click="triggerUpload('front')"
                @dragover.prevent="dragOver = 'front'"
                @dragleave.prevent="dragOver = null"
                @drop.prevent="handleDrop($event, 'front')"
              >
                <!-- 上传中 -->
                <template v-if="uploading === 'front'">
                  <div class="upload-spinner"></div>
                  <span class="upload-hint">上传中...</span>
                </template>
                <!-- 未上传 -->
                <template v-else-if="!form.idFrontImage">
                  <svg viewBox="0 0 24 24" width="40" height="40">
                    <path
                      d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                      fill="currentColor"
                    />
                  </svg>
                  <span class="upload-hint">点击上传</span>
                  <span class="upload-sub-hint"
                    >支持 JPG / PNG，建议 5MB 以内</span
                  >
                </template>
                <!-- 已上传 -->
                <template v-else>
                  <img
                    :src="form.idFrontImage"
                    class="upload-preview"
                    alt="身份证正面"
                  />
                  <div class="upload-overlay">
                    <span>重新上传</span>
                  </div>
                </template>
              </div>
              <input
                type="file"
                ref="frontInput"
                accept="image/*"
                style="display: none"
                @change="handleFileChange($event, 'front')"
              />
            </div>

            <!-- 背面照 -->
            <div class="upload-item">
              <div class="upload-label">
                <span class="upload-name">背面照</span>
                <span class="label-required">*</span>
              </div>
              <div
                class="upload-area"
                :class="{
                  'has-image': form.idBackImage,
                  uploading: uploading === 'back',
                  dragover: dragOver === 'back',
                }"
                @click="triggerUpload('back')"
                @dragover.prevent="dragOver = 'back'"
                @dragleave.prevent="dragOver = null"
                @drop.prevent="handleDrop($event, 'back')"
              >
                <template v-if="uploading === 'back'">
                  <div class="upload-spinner"></div>
                  <span class="upload-hint">上传中...</span>
                </template>
                <template v-else-if="!form.idBackImage">
                  <svg viewBox="0 0 24 24" width="40" height="40">
                    <path
                      d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                      fill="currentColor"
                    />
                  </svg>
                  <span class="upload-hint">点击上传</span>
                  <span class="upload-sub-hint"
                    >支持 JPG / PNG，建议 5MB 以内</span
                  >
                </template>
                <template v-else>
                  <img
                    :src="form.idBackImage"
                    class="upload-preview"
                    alt="身份证背面"
                  />
                  <div class="upload-overlay">
                    <span>重新上传</span>
                  </div>
                </template>
              </div>
              <input
                type="file"
                ref="backInput"
                accept="image/*"
                style="display: none"
                @change="handleFileChange($event, 'back')"
              />
            </div>
          </div>

          <!-- 手持照片 -->
          <div class="form-group">
            <label class="form-label">
              <span class="label-text">手持身份证照片</span>
              <span class="label-required">*</span>
            </label>
            <div class="upload-item-full">
              <div
                class="upload-area upload-area-full"
                :class="{
                  'has-image': form.idHandImage,
                  uploading: uploading === 'hand',
                  dragover: dragOver === 'hand',
                }"
                @click="triggerUpload('hand')"
                @dragover.prevent="dragOver = 'hand'"
                @dragleave.prevent="dragOver = null"
                @drop.prevent="handleDrop($event, 'hand')"
              >
                <template v-if="uploading === 'hand'">
                  <div class="upload-spinner"></div>
                  <span class="upload-hint">上传中...</span>
                </template>
                <template v-else-if="!form.idHandImage">
                  <svg viewBox="0 0 24 24" width="48" height="48">
                    <path
                      d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                      fill="currentColor"
                    />
                  </svg>
                  <span class="upload-hint">点击上传手持身份证照片</span>
                  <span class="upload-sub-hint"
                    >请手持身份证拍摄，确保面部和身份证信息清晰可见</span
                  >
                </template>
                <template v-else>
                  <img
                    :src="form.idHandImage"
                    class="upload-preview"
                    alt="手持身份证"
                  />
                  <div class="upload-overlay">
                    <span>重新上传</span>
                  </div>
                </template>
              </div>
              <input
                type="file"
                ref="handInput"
                accept="image/*"
                style="display: none"
                @change="handleFileChange($event, 'hand')"
              />
            </div>
          </div>

          <!-- ===== 提交承诺 ===== -->
          <!-- <div class="form-agreement">
            <label class="agreement-check">
              <input type="checkbox" v-model="agreeTerms" />
              <span class="checkmark"></span>
            </label>
            <span class="agreement-text">
              本人承诺以上填写信息及上传照片真实有效，并同意
              <a href="#" @click.prevent="handleTerms">《认证服务协议》</a>
              与
              <a href="#" @click.prevent="handlePrivacy">《隐私保护政策》</a>
            </span>
          </div> -->

          <!-- 审核提示 -->
          <div class="audit-notice">
            <svg viewBox="0 0 24 24" width="18" height="18">
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                fill="currentColor"
              />
            </svg>
            <span>
              <strong>提交后将进行人工审核</strong>，审核结果将在
              <strong>24小时内</strong> 通知您，请确保信息真实准确。
            </span>
          </div>

          <!-- 提交按钮 -->
          <button type="submit" class="submit-btn" :disabled="isSubmitting">
            <span v-if="!isSubmitting">提交认证</span>
            <span v-else class="submitting">
              <span class="spinner"></span>
              提交中...
            </span>
            <span class="btn-glow"></span>
          </button>
        </form>

        <!-- 底部 -->
        <div class="verify-footer">
          <span class="footer-line"></span>
          <p>已有账号？</p>
          <button type="button" class="goto-login" @click="handleBack">
            去登录
            <span class="goto-arrow">→</span>
          </button>
        </div>
      </div>
    </template>
    <template v-else>
      <Review v-if="auth?.auth_status == 1" />
      <Approved v-if="auth?.auth_status == 2" />
    </template>
    <!-- 提交成功弹窗 -->
    <div v-if="showSuccessModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-icon">✅</div>
        <h2>提交成功！</h2>
        <p>
          您的认证信息已提交，我们将在
          <strong>24小时内</strong> 完成审核。<br />
          审核结果将通过短信通知您。
        </p>
        <p class="modal-tip">请保持手机畅通，感谢您的配合！</p>
        <button class="modal-btn" @click="closeModal">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
import Approved from "@/components/apply/Approved.vue";
import Review from "@/components/apply/Review.vue";
import LangSwitcher from "@/components/LangSwitcher.vue";
export default {
  name: "IdentityVerifyComponent",
  components: {
    Approved,
    Review,
    LangSwitcher,
  },
  data() {
    return {
      step: 1,
      auth: {},
      form: {
        code: "", //链接中的code
        password: "", // 🆕 密码
        confirmPassword: "", // 🆕 确认密码
        tradePassword: "", // 🆕 密码
        confirmTradePassword: "", // 🆕 确认密码
        securityQuestion: "", // 🆕 安全问题
        securityQuestionAnswer: "", // 🆕 安全问题答案
        targetCountries: [],
        phone: "",
        realName: "",
        idNumber: "",
        idFrontImage: null, // 接口返回的图片路径
        idBackImage: null,
        idHandImage: null,
      },
      allCountries: ["中国", "俄罗斯", "美国", "日本", "韩国"],
      selectedCountries: [],
      countryDropdownOpen: false,
      agreeTerms: false,
      isSubmitting: false,
      showSuccessModal: false,
      dragOver: null,
      uploading: null, // 当前正在上传的类型: 'front' | 'back' | 'hand'
      showPassword: false, // 🆕 显示密码
      showConfirmPassword: false, // 🆕 显示确认密码
      showTradePassword: false, // 🆕 显示交易密码
      showConfirmTradePassword: false, // 🆕 显示确认交易密码
    };
  },
  watch: {
    selectedCountries(val) {
      this.form.targetCountries = val;
    },
  },
  created() {
    this.form.code = this.$route.query.code || "";
    this.checkCode();
  },
  methods: {
    async checkCode() {
      try {
        const res = await this.$api.userUrl.checkCode({
          code: this.form.code,
        });
        if (res.code === 1) {
          this.$router.push({ name: "Error" });
          return;
        }
        this.auth = res.data;
        if (this.auth?.auth_status == 1 || this.auth?.auth_status == 2) {
          this.step = 2;
        }
      } catch (error) {
        console.error("校验失败:", error);
        // this.$message.error("校验失败");
      }
    },
    // ===== 国家选择 =====
    toggleCountryDropdown() {
      this.countryDropdownOpen = !this.countryDropdownOpen;
    },
    toggleCountry(country) {
      const index = this.selectedCountries.indexOf(country);
      if (index > -1) {
        this.selectedCountries.splice(index, 1);
      } else {
        this.selectedCountries.push(country);
      }
    },
    removeCountry(country) {
      const index = this.selectedCountries.indexOf(country);
      if (index > -1) {
        this.selectedCountries.splice(index, 1);
      }
    },
    handleClickOutside(e) {
      if (this.countryDropdownOpen) {
        const wrapper = this.$el.querySelector(".country-select-wrapper");
        if (wrapper && !wrapper.contains(e.target)) {
          this.countryDropdownOpen = false;
        }
      }
    },

    // ===== 文件上传 =====
    triggerUpload(type) {
      const refMap = {
        front: "frontInput",
        back: "backInput",
        hand: "handInput",
      };
      this.$refs[refMap[type]]?.click();
    },

    handleFileChange(event, type) {
      const file = event.target.files[0];
      if (file) {
        this.uploadFile(file, type);
      }
      event.target.value = "";
    },

    handleDrop(event, type) {
      this.dragOver = null;
      const file = event.dataTransfer.files[0];
      if (file) {
        this.uploadFile(file, type);
      }
    },

    async uploadFile(file, type) {
      // 校验文件类型
      if (!file.type.startsWith("image/")) {
        this.$message.warning("请上传图片文件");
        return;
      }
      // 校验文件大小（5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning("图片大小不能超过 5MB");
        return;
      }

      // 设置上传状态
      this.uploading = type;

      try {
        // 构建 FormData
        const formData = new FormData();
        formData.append("file", file);

        // 调用上传接口
        const response = await this.$api.file.upload(formData);

        // 假设接口返回格式为 { code: 0, data: { path: "/uploads/xxx.jpg" } }
        if (response.code === 0 && response.data?.path) {
          // 拼接完整图片地址（根据实际接口返回调整）
          const imageUrl = response.data.path;

          // 保存图片路径到对应的字段
          const fieldMap = {
            front: "idFrontImage",
            back: "idBackImage",
            hand: "idHandImage",
          };
          this.form[fieldMap[type]] = imageUrl;

          this.$message.success("图片上传成功");
        } else {
          this.$message.error(response.msg || "图片上传失败");
        }
      } catch (error) {
        console.error("上传失败:", error);
        this.$message.error("图片上传失败，请稍后重试");
      } finally {
        this.uploading = null;
      }
    },
    validForm() {
      // ====== 表单校验 ======

      // 🆕 密码校验
      if (!this.form.password || this.form.password.length < 6) {
        this.$message.warning("密码至少为6位");
        return false;
      }

      // 🆕 确认密码校验
      if (!this.form.confirmPassword) {
        this.$message.warning("请再次输入密码");
        return false;
      }

      // 🆕 密码一致性校验
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.warning("两次输入的密码不一致");
        return false;
      }

      // 🆕 密码校验
      if (!this.form.tradePassword || this.form.tradePassword.length < 6) {
        this.$message.warning("交易密码至少为6位");
        return false;
      }

      // 🆕 确认密码校验
      if (!this.form.confirmTradePassword) {
        this.$message.warning("请再次输入交易密码");
        return false;
      }

      // 🆕 密码一致性校验
      if (this.form.tradePassword !== this.form.confirmTradePassword) {
        this.$message.warning("两次输入的交易密码不一致");
        return false;
      }

      if (this.form.securityQuestion.length === 0) {
        this.$message.warning("请输入安全问题");
        return false;
      }

      if (this.selectedCountries.length === 0) {
        this.$message.warning("请至少选择一个目标国家");
        return false;
      }

      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!this.form.phone || !phoneRegex.test(this.form.phone)) {
        this.$message.warning("请输入有效的手机号码");
        return false;
      }

      if (!this.form.realName || this.form.realName.length < 2) {
        this.$message.warning("请输入真实姓名（至少2位）");
        return false;
      }

      if (!this.form.idNumber) {
        this.$message.warning("请输入有效的身份证号码");
        return false;
      }

      if (!this.form.idFrontImage) {
        this.$message.warning("请上传身份证正面照");
        return false;
      }

      if (!this.form.idBackImage) {
        this.$message.warning("请上传身份证背面照");
        return false;
      }

      if (!this.form.idHandImage) {
        this.$message.warning("请上传手持身份证照片");
        return false;
      }

      return true;
    },

    // ===== 表单提交 =====
    async handleSubmit() {
      // 校验表单
      if (!this.validForm()) {
        return;
      }

      // if (!this.agreeTerms) {
      //   this.$message.warning("请先阅读并同意认证服务协议与隐私政策");
      //   return;
      // }

      // ====== 提交 ======
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;

      try {
        // 调用提交接口
        const res = await this.$api.user.verify(this.form);
        if (res.code === 0) {
          this.checkCode();
          this.$message.success("提交成功");
        } else {
          this.$message.error(res.msg || "提交失败");
          return;
        }

        // 模拟 API 请求
        // await new Promise((resolve) => setTimeout(resolve, 1500));
        this.showSuccessModal = true;
      } catch (error) {
        console.error("提交失败:", error);
        this.$message.error("提交失败，请稍后重试");
      } finally {
        this.isSubmitting = false;
      }
    },

    resetForm() {
      this.selectedCountries = [];
      this.form = {
        targetCountries: [],
        phone: "",
        realName: "",
        idNumber: "",
        idFrontImage: null,
        idBackImage: null,
        idHandImage: null,
      };
      this.agreeTerms = false;
    },

    closeModal() {
      this.showSuccessModal = false;
    },

    handleBack() {
      this.$router.push({ name: "Login" });
    },

    handleTerms() {
      console.log("查看认证服务协议");
    },

    handlePrivacy() {
      console.log("查看隐私保护政策");
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
/* ===== 容器 ===== */
.verify-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 20px 0;
}

/* ===== 背景图层 ===== */
.bg-layer {
  position: absolute;
  inset: 0;
  background-image: url("@/assets/imgs/dlbj.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scale(1.05);
  z-index: 0;
}

/* ===== 认证卡片 ===== */
.verify-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 580px;
  padding: 32px 40px 28px;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  max-height: 95vh;
  overflow-y: auto;
}

.verify-card::-webkit-scrollbar {
  width: 4px;
}

.verify-card::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.verify-card::-webkit-scrollbar-thumb {
  background: rgba(0, 180, 255, 0.3);
  border-radius: 4px;
}

.verify-card:hover {
  border-color: rgba(100, 200, 255, 0.2);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6), 0 0 60px rgba(0, 150, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

/* ===== 返回按钮 ===== */
.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  cursor: pointer;
  padding: 4px 0;
  transition: all 0.3s ease;
  font-family: inherit;
  margin-bottom: 12px;
}

.back-btn:hover {
  color: #00b4ff;
  transform: translateX(-4px);
}

/* ===== 头部 ===== */
.verify-header {
  text-align: center;
  margin-bottom: 28px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 180, 255, 0.15);
  border: 1px solid rgba(0, 180, 255, 0.2);
  border-radius: 20px;
  padding: 4px 16px 4px 12px;
  font-size: 12px;
  color: #66ccff;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00ff88;
  animation: pulse-dot 2s infinite;
}

@keyframes pulse-dot {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.8);
  }
}

.title {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
  margin: 0 0 4px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.45);
  letter-spacing: 0.5px;
  margin: 0;
}

/* ===== 表单 ===== */
.verify-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===== 分区标题 ===== */
.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 1px;
  margin: 6px 0 2px;
}

.section-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
}

/* ===== 表单项 ===== */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

.label-required {
  color: #ff4757;
  font-size: 16px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 14px;
  color: rgba(255, 255, 255, 0.3);
  z-index: 2;
  pointer-events: none;
  transition: color 0.3s;
  display: flex;
  align-items: center;
}

.form-input {
  width: 100%;
  padding: 12px 14px 12px 44px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}

.form-input:focus {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(0, 150, 255, 0.5);
  box-shadow: 0 0 0 4px rgba(0, 100, 255, 0.1);
}

.input-wrapper:focus-within .input-icon {
  color: #00b4ff;
}

/* ===== 国家选择器 ===== */
.country-select-wrapper {
  position: relative;
}

.country-select {
  position: relative;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.country-select:hover {
  border-color: rgba(255, 255, 255, 0.2);
}

.country-select.active {
  border-color: rgba(0, 150, 255, 0.5);
  box-shadow: 0 0 0 4px rgba(0, 100, 255, 0.1);
}

.country-select-display {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  min-height: 48px;
}

.country-select-display .placeholder {
  color: rgba(255, 255, 255, 0.25);
  font-size: 14px;
}

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
}

.country-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(0, 180, 255, 0.2);
  border: 1px solid rgba(0, 180, 255, 0.3);
  border-radius: 16px;
  padding: 3px 6px 3px 12px;
  font-size: 13px;
  color: #66ccff;
}

.tag-remove {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  font-size: 16px;
  padding: 0 2px;
  transition: color 0.3s;
  line-height: 1;
}

.tag-remove:hover {
  color: #ff4757;
}

.dropdown-arrow {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.3);
  transition: transform 0.3s ease;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.country-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: rgba(20, 30, 45, 0.98);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 6px 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.country-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.country-option:hover {
  background: rgba(0, 180, 255, 0.1);
}

.country-option .country-check {
  color: #00b4ff;
  font-weight: 600;
  font-size: 16px;
}

/* ===== 上传区域 ===== */
.upload-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.upload-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.upload-item-full {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.upload-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

.upload-name {
  color: rgba(255, 255, 255, 0.7);
}

.upload-area {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 140px;
  background: rgba(255, 255, 255, 0.04);
  border: 2px dashed rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 16px;
  overflow: hidden;
}

.upload-area:hover {
  border-color: rgba(0, 180, 255, 0.3);
  background: rgba(255, 255, 255, 0.06);
}

.upload-area.dragover {
  border-color: #00b4ff;
  background: rgba(0, 180, 255, 0.08);
  box-shadow: 0 0 0 4px rgba(0, 100, 255, 0.1);
}

.upload-area.has-image {
  border-color: rgba(0, 200, 100, 0.3);
  min-height: 160px;
}

.upload-area.uploading {
  border-color: #ffb300;
  background: rgba(255, 179, 0, 0.08);
  cursor: default;
}

.upload-area svg {
  color: rgba(255, 255, 255, 0.2);
}

.upload-hint {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

.upload-sub-hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.25);
  text-align: center;
}

.upload-preview {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  border-radius: 10px;
}

.upload-area:hover .upload-overlay {
  opacity: 1;
}

.upload-area-full {
  min-height: 200px;
}

.upload-area-full.upload-area.has-image {
  min-height: 220px;
}

/* ===== 上传旋转动画 ===== */
.upload-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: #ffb300;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* ===== 协议勾选 ===== */
.form-agreement {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 4px;
}

.agreement-check {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 2px;
}

.agreement-check input {
  display: none;
}

.agreement-check .checkmark {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  transition: all 0.3s ease;
  position: relative;
}

.agreement-check input:checked + .checkmark {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border-color: #00b4ff;
}

.agreement-check input:checked + .checkmark::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.agreement-text {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  line-height: 1.6;
}

.agreement-text a {
  color: #00b4ff;
  text-decoration: none;
  transition: color 0.3s;
}

.agreement-text a:hover {
  color: #66ccff;
  text-decoration: underline;
}

/* ===== 审核提示 ===== */
.audit-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: rgba(0, 180, 255, 0.08);
  border: 1px solid rgba(0, 180, 255, 0.12);
  border-radius: 10px;
  padding: 12px 14px;
  margin-top: 2px;
}

.audit-notice svg {
  flex-shrink: 0;
  margin-top: 1px;
  color: #00b4ff;
}

.audit-notice span {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  line-height: 1.6;
}

.audit-notice strong {
  color: #66ccff;
  font-weight: 600;
}

/* ===== 提交按钮 ===== */
.submit-btn {
  position: relative;
  padding: 15px;
  margin-top: 4px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  letter-spacing: 2px;
  font-family: inherit;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 100, 255, 0.35);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 4px 20px rgba(0, 100, 255, 0.2);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none !important;
}

.btn-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  opacity: 0;
  transition: opacity 0.6s;
  pointer-events: none;
}

.submit-btn:hover:not(:disabled) .btn-glow {
  opacity: 1;
}

.submitting {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== 底部 ===== */
.verify-footer {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.footer-line {
  display: block;
  width: 40px;
  height: 2px;
  margin: 0 auto 10px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.15),
    transparent
  );
  border-radius: 2px;
}

.verify-footer p {
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  margin: 0;
}

.goto-login {
  background: transparent;
  border: none;
  color: #00b4ff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s ease;
  font-family: inherit;
  position: relative;
}

.goto-login::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #00b4ff, #0066ff);
  transition: width 0.3s ease;
}

.goto-login:hover {
  color: #66ccff;
  transform: translateX(4px);
}

.goto-login:hover::after {
  width: 100%;
}

.goto-arrow {
  display: inline-block;
  transition: transform 0.3s ease;
}

.goto-login:hover .goto-arrow {
  transform: translateX(4px);
}

/* ===== 成功弹窗 ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: linear-gradient(145deg, #1a2a3a, #0f1a26);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px 48px 36px;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 40px 80px rgba(0, 0, 0, 0.6);
  animation: slideUp 0.4s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-icon {
  font-size: 56px;
  margin-bottom: 12px;
}

.modal-content h2 {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 12px;
}

.modal-content p {
  color: rgba(255, 255, 255, 0.65);
  font-size: 15px;
  line-height: 1.8;
  margin: 0 0 8px;
}

.modal-content p strong {
  color: #66ccff;
}

.modal-tip {
  color: rgba(255, 255, 255, 0.4);
  font-size: 13px !important;
  margin-top: 4px !important;
}

.modal-btn {
  margin-top: 20px;
  padding: 12px 40px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 100, 255, 0.3);
}

/* ===== 响应式适配 ===== */
@media (max-width: 640px) {
  .verify-card {
    padding: 20px 16px 20px;
    border-radius: 16px;
    margin: 12px;
    max-height: 98vh;
  }

  .title {
    font-size: 22px;
  }

  .subtitle {
    font-size: 12px;
  }

  .upload-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .upload-area {
    min-height: 120px;
  }

  .upload-area-full {
    min-height: 160px;
  }

  .form-input {
    padding: 11px 12px 11px 40px;
    font-size: 14px;
  }

  .submit-btn {
    padding: 13px;
    font-size: 15px;
  }

  .bg-layer {
    filter: blur(8px) brightness(0.6);
    -webkit-filter: blur(8px) brightness(0.6);
  }

  .verify-footer {
    flex-direction: column;
    gap: 4px;
  }

  .agreement-text {
    font-size: 12px;
  }

  .section-title {
    font-size: 12px;
  }

  .modal-content {
    padding: 28px 20px 24px;
  }

  .modal-content h2 {
    font-size: 20px;
  }

  .status-badge {
    font-size: 11px;
    padding: 3px 12px 3px 10px;
  }

  .audit-notice {
    padding: 10px 12px;
  }

  .audit-notice span {
    font-size: 12px;
  }
}

@media (max-width: 380px) {
  .verify-card {
    padding: 16px 12px 16px;
  }

  .title {
    font-size: 19px;
  }

  .form-input {
    padding: 10px 10px 10px 36px;
    font-size: 13px;
  }

  .input-icon svg {
    width: 17px;
    height: 17px;
  }

  .input-icon {
    left: 11px;
  }

  .country-select-display {
    padding: 8px 10px;
    min-height: 42px;
  }
}

/* ===== 密码显示切换按钮 ===== */
.password-toggle {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  padding: 4px;
  transition: all 0.3s ease;
  z-index: 3;
  display: flex;
  align-items: center;
}

.password-toggle:hover {
  color: rgba(255, 255, 255, 0.7);
}

/* 响应式适配 */
@media (max-width: 520px) {
  .password-toggle {
    right: 10px;
  }
}
/* ===== 右上角语言切换 ===== */
.register-lang {
  position: absolute;
  top: 20px;
  right: 24px;
  z-index: 10;
}
</style>
